<template>
  <div class="charts-box">
    <qiun-vue-ucharts 
      type="ring"
      :opts="opts"
      :chartData="chartData"
      class="charts"
    />
  </div>
</template>

<script>
import qiunVueUcharts from '@qiun/vue-ucharts'

export default {
    components: {
        qiunVueUcharts
    },
    props: {
        ringTpey: {
            type: Array,
            default: () => []
        },
  },
  data() {
    return {
      chartData: {},
      //您可以通过修改 config-ucharts.js 文件中下标为 ['ring'] 的节点来配置全局默认参数，如都是默认参数，此处可以不传 opts 。实际应用过程中 opts 只需传入与全局默认参数中不一致的【某一个属性】即可实现同类型的图表显示不同的样式，达到页面简洁的需求。
      opts: {
        rotate: false,
        rotateLock: false,
        color: ["#0698ff","#00cea7","#fb983a","#EE6666","#73C0DE","#3CA272","#FC8452","#9A60B4","#ea7ccc"],
        padding: [0,0,0,0],
        dataLabel: true,
        enableScroll: false,
        legend: {
          show: false,
          position: "right",
          lineHeight: 25
        },
        title: {
          name: "总房量",
          fontSize: 15,
          color: "#666666"
        },
        subtitle: {
          name: "200 间",
          fontSize: 20,
          color: "#333"
        },
        extra: {
          ring: {
            ringWidth: 20,
            activeOpacity: 0.5,
            activeRadius: 10,
            offsetAngle: 0,
            labelWidth: 1,
            border: true,
            borderWidth: 3,
            borderColor: "#FFFFFF"
          }
        }
      }
    };
  },
  mounted() {
  },
  watch: {
    ringTpey: {
      handler(newVal, oldVal) {
        this.getServerData();
      },
      deep: true
    }
  },
  methods: {
    getServerData() {
        //模拟服务器返回数据，如果数据格式和标准格式不同，需自行按下面的格式拼接
        this.opts.subtitle.name = (this.ringTpey[0].value+this.ringTpey[1].value )+ '间';
        let res = {
            series: [
              {
                data: [...this.ringTpey]
              }
            ]
          };
        this.chartData = JSON.parse(JSON.stringify(res));
    },
  }
};
</script>

<style scoped>
  /* 请根据实际需求修改父元素尺寸，组件自动识别宽高 */
  .charts-box {
    width: 250px;
    height: 200px;
  }
</style>